module.exports = __webpack_public_path__ + "img/image05.4ab194ed.jpg";